import React from 'react';
import { Button, ButtonProps } from '../ui/Button';

interface RpgButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: "default" | "success" | "warning" | "neutral" | "danger";
  children?: React.ReactNode;
  className?: string;
}

/**
 * @deprecated Use Button from '../ui/Button' instead.
 * This component is a wrapper for backward compatibility.
 */
export const RpgButton = ({
  children,
  variant = "default",
  className = "",
  ...props
}: RpgButtonProps) => {
  // Map legacy variants to new Button variants
  const buttonVariant = variant === "default" ? "primary" : variant;

  return (
    <Button
      variant={buttonVariant}
      className={className}
      {...props}
    >
      {children}
    </Button>
  );
};